export const resetState = () => ({
    type: "RESET_STATE",
});

export const accessToken = (access_token) => ({
    type: 'ACCESS_TOKEN',
    payload: access_token,
});

export const menus = (menus) => ({
    type: 'MENU',
    payload: menus,
});

export const userName = (user_name) => ({
    type: 'USER_NAME',
    payload: user_name,
});

export const userEmail = (user_email) => ({
    type: 'USER_EMAIL',
    payload: user_email,
});

export const updateProfileImage = (imageUrl) => ({
    type: 'UPDATE_PROFILE_IMAGE',
    payload: imageUrl,
});

export const googleApiTime = (googleApiTime) => ({
    type: 'GOOGLE_API_TIME',
    payload: googleApiTime,
});